import { apiClient } from "./base.service";
import { getAuth } from "firebase/auth";

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
  timestamp: string;
}

export interface ChatRequest {
  message: string;
  conversationHistory: ChatMessage[];
}

export interface ChatResponse {
  response: string;
  conversationId: string;
  timestamp: string;
}

export interface Conversation {
  id: string;
  userId: string;
  messages: ChatMessage[];
  createdAt: string;
  updatedAt: string;
}

export class ChatAPIService {
  private async getAuthHeaders() {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }

    const token = await user.getIdToken();
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }

  async sendMessage(
    startupId: string,
    request: ChatRequest
  ): Promise<ChatResponse> {
    const headers = await this.getAuthHeaders();
    return apiClient.post(`/startups/${startupId}/chat`, request, { headers });
  }

  async getConversations(startupId: string): Promise<Conversation[]> {
    const headers = await this.getAuthHeaders();
    return apiClient.get(`/startups/${startupId}/conversations`, { headers });
  }
}

export const chatAPI = new ChatAPIService();
